import { createTheme, PaletteOptions } from "@mui/material"

import {
  resolveTheme,
  UISK_Theme,
  UISK_Variables,
} from "@/generated/generatedTheme"
import { ThemeName } from "@/theme"

import { components } from "./components"
import { constants } from "./constants"

const getRadius = (radius: UISK_Variables["2. Radius"]) =>
  Object.entries(radius).map(([key, value]) => {
    const cleanKey = key.split("-").at(-1) as string
    const pxValue = `${value}px`
    return [cleanKey, pxValue]
  })

const getPalette = (colors: UISK_Variables["1. Color modes"]) =>
  Object.fromEntries(
    Object.entries(colors).map(([key, value]) => {
      const cleanKey = key.split("/").at(-1)?.split(" ").at(0)
      return [cleanKey, value]
    }),
  )

const getSpacing = (spacing: UISK_Variables["3. Spacing"]) =>
  Object.entries(spacing).map(([key, value]) => {
    const cleanKey = key.split("-").at(-1) as string
    const pxValue = `${value}px`
    return [cleanKey, pxValue]
  })

const getTheme = (theme: UISK_Theme) => {
  const { variables, textStyles } = theme

  const palette = getPalette(
    variables["1. Color modes"],
  ) as unknown as PaletteOptions
  palette.positive = palette["utility-data-positive-500"]
  palette.negative = palette["utility-red-600"]

  const radius = getRadius(variables["2. Radius"])
  const spacing = getSpacing(variables["3. Spacing"])

  return createTheme({
    palette: {
      mode:
        theme.currentModes["1. Color modes"] === "Dark mode"
          ? ThemeName.Dark
          : ThemeName.Light,
      ...palette,
    },
    uisk: {
      radius: Object.fromEntries(radius),
      spacing: Object.fromEntries(spacing),
    },
    typography: textStyles,
    components: components,
    constants: constants,
  })
}

export const darkTheme = getTheme(
  resolveTheme({ "1. Color modes": "Dark mode" }),
)
export const lightTheme = getTheme(
  resolveTheme({ "1. Color modes": "Light mode" }),
)

export const themes = { light: lightTheme, dark: darkTheme }
